/*
 * 资质附件模块 - 纯函数
 */
import {
  AttachTypeEnum,
  AttachTypeList,
} from '@/global/enum/categoryQualification'
import { AptitudeFile } from './typing'

// 资质类型 code 字面量联合
type AttachTypeCode = (typeof AttachTypeList)[number]['value']

// 按 code 取资质类型 label（集中处理类型转换）
export const getAttachTypeLabel = (value: string): string =>
  AttachTypeEnum.getLabelByValue(value as AttachTypeCode) || value

// 支持的上传文件扩展名
export const APTITUDE_ACCEPT_EXT = '.jpg,.png,.pdf'

// accept 属性（input accept / Upload accept）
export const APTITUDE_ACCEPT = APTITUDE_ACCEPT_EXT

// 单文件大小上限（10MB）
export const APTITUDE_MAX_SIZE = 10 * 1024 * 1024

// 商品详情返参 auditType（ADD/MODIFY）→ 资质场景 scene
// MODIFY → 修改审核(SRM_UPDATE)；ADD/缺省 → 新增二审(SRM_SECOND_ADD)
export const getSceneByAuditType = (auditType?: string): string =>
  auditType === 'MODIFY' ? 'SRM_UPDATE' : 'SRM_SECOND_ADD'

// 物料类型 → 资质配置货主默认值
// 电商供应商物料(materialType=2) → 1000；供应商物料(materialType=1) → 1025
export const getOwnerByMaterialType = (materialType?: string): string =>
  materialType === '2' ? '1000' : '1025'

// 计算缺失的必传资质类型（必传 - 已上传类型）
export const getMissingRequiredTypes = (
  required: string[] = [],
  list: AptitudeFile[] = [],
): string[] => {
  const uploaded = new Set(list.map((item) => item.docType))
  return required.filter((type) => !uploaded.has(type))
}

// 构造必填提示文案：展示配置返回的全部必传资质类型（初始数据）
// 注意：仅按必传类型展示，不随已上传文件做减法、不隐藏；
// 是否真正缺失由提交校验用 getMissingRequiredTypes 判断
export const buildRequiredTip = (required: string[] = []): string => {
  if (!required.length) return ''
  const labels = required.map((type) => getAttachTypeLabel(type))
  return `必传资质：${labels.join('、')}`
}

// 同一资质类型下文件名是否重复（跨「主列表 + 暂存列表」）
export const isDuplicateFileName = (
  fileName: string,
  attachType: string,
  ...lists: AptitudeFile[][]
): boolean =>
  lists.some((list) =>
    list.some((item) => item.docType === attachType && item.name === fileName),
  )
/*
 * 资质附件模块 - 纯函数
 */
import {
  AttachTypeEnum,
  AttachTypeList,
} from '@/global/enum/categoryQualification'
import { AptitudeFile } from './typing'

// 资质类型 code 字面量联合
type AttachTypeCode = (typeof AttachTypeList)[number]['value']

// 按 code 取资质类型 label（集中处理类型转换）
export const getAttachTypeLabel = (value: string): string =>
  AttachTypeEnum.getLabelByValue(value as AttachTypeCode) || value

// 支持的上传文件扩展名
export const APTITUDE_ACCEPT_EXT = '.jpg,.png,.pdf'

// accept 属性（input accept / Upload accept）
export const APTITUDE_ACCEPT = APTITUDE_ACCEPT_EXT

// 单文件大小上限（10MB）
export const APTITUDE_MAX_SIZE = 10 * 1024 * 1024

// 商品详情返参 auditType（ADD/MODIFY）→ 资质场景 scene
// MODIFY → 修改审核(SRM_UPDATE)；ADD/缺省 → 新增二审(SRM_SECOND_ADD)
export const getSceneByAuditType = (auditType?: string): string =>
  auditType === 'MODIFY' ? 'SRM_UPDATE' : 'SRM_SECOND_ADD'

// 物料类型 → 资质配置货主默认值
// 电商供应商物料(materialType=2) → 1000；供应商物料(materialType=1) → 1025
export const getOwnerByMaterialType = (materialType?: string): string =>
  materialType === '2' ? '1000' : '1025'

// 计算缺失的必传资质类型（必传 - 已上传类型）
export const getMissingRequiredTypes = (
  required: string[] = [],
  list: AptitudeFile[] = [],
): string[] => {
  const uploaded = new Set(list.map((item) => item.docType))
  return required.filter((type) => !uploaded.has(type))
}

// 构造必填提示文案：展示配置返回的全部必传资质类型（初始数据）
// 注意：仅按必传类型展示，不随已上传文件做减法、不隐藏；
// 是否真正缺失由提交校验用 getMissingRequiredTypes 判断
export const buildRequiredTip = (required: string[] = []): string => {
  if (!required.length) return ''
  const labels = required.map((type) => getAttachTypeLabel(type))
  return `必传资质：${labels.join('、')}`
}

// 同一资质类型下文件名是否重复（跨「主列表 + 暂存列表」）
export const isDuplicateFileName = (
  fileName: string,
  attachType: string,
  ...lists: AptitudeFile[][]
): boolean =>
  lists.some((list) =>
    list.some((item) => item.docType === attachType && item.name === fileName),
  )
